import { render, staticRenderFns } from "./LoadSummary.vue?vue&type=template&id=654cb734"
import script from "./LoadSummary.vue?vue&type=script&lang=js"
export * from "./LoadSummary.vue?vue&type=script&lang=js"
import style0 from "./LoadSummary.vue?vue&type=style&index=0&id=654cb734&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654cb734')) {
      api.createRecord('654cb734', component.options)
    } else {
      api.reload('654cb734', component.options)
    }
    module.hot.accept("./LoadSummary.vue?vue&type=template&id=654cb734", function () {
      api.rerender('654cb734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Loads/LoadSummary.vue"
export default component.exports